import { useQuery } from '@tanstack/react-query';

import { fetchBanners, FetchBannersResponse } from '../api/entryPage/fetchBanners';
import { GlobalReactQueryOptions } from '../config';
import { AgeCategory } from '../../models/AgeCategory';
import { BannerCategory } from '../../models/Banners';
import { LoanFormat } from '../../models/LoanFormat';
import { UseQueryResult } from '../api/query-types';

type UseBannersQuery = UseQueryResult<'data', FetchBannersResponse>;

type UseBannersOptions = {
    readonly fetchFunc?: typeof fetchBanners;
    readonly loanFormat?: LoanFormat;
    readonly ageCategory?: AgeCategory;
    readonly categoryKey?: string;
};

const emptyBanners = [];

export const useBannersQuery = (
    categoryPage: BannerCategory,
    { fetchFunc = fetchBanners, loanFormat, ageCategory, categoryKey }: UseBannersOptions = {}
): UseBannersQuery => {
    const params = {
        loanFormat,
        ageCategory,
        categoryKey
    };
    const { data, ...result } = useQuery(['banners', categoryPage, params], () => fetchFunc(categoryPage, params), {
        ...GlobalReactQueryOptions
    });

    return {
        ...result,
        data: data ?? emptyBanners
    };
};
